import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import type { RevenueReportResponse, UtilizationReportResponse } from '@/api/types';

export function useRevenueReport(
  startDate: string,
  endDate: string,
  groupBy = 'DAY',
  locationId?: string,
) {
  const params = new URLSearchParams({
    startDate,
    endDate,
    groupBy,
  });
  if (locationId) params.set('locationId', locationId);
  return useQuery({
    queryKey: ['revenueReport', startDate, endDate, groupBy, locationId],
    queryFn: () =>
      apiClient<RevenueReportResponse>(`/admin/reports/revenue?${params.toString()}`),
    enabled: !!startDate && !!endDate,
  });
}

export function useUtilizationReport(
  startDate: string,
  endDate: string,
  locationId?: string,
) {
  const params = new URLSearchParams({ startDate, endDate });
  if (locationId) params.set('locationId', locationId);
  return useQuery({
    queryKey: ['utilizationReport', startDate, endDate, locationId],
    queryFn: () =>
      apiClient<UtilizationReportResponse>(`/admin/reports/utilization?${params.toString()}`),
    enabled: !!startDate && !!endDate,
  });
}
